import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

const HUEHOPPERS_BACKEND_URL = "https://backend.huehoppers.com";
const HUEHOPPERS_FRONTEND_URL = "https://huehoppers.com";

export default function HueHoppersPaymentRedirect() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // ── Case 1: Coming FROM HueHoppers → go to Razorpay payment link ──
    const paymentLink = searchParams.get("link");
    if (paymentLink) {
      window.location.href = decodeURIComponent(paymentLink);
      return;
    }

    // ── Case 2: Returning FROM Razorpay → go back to HueHoppers ──
    const status = searchParams.get("razorpay_payment_link_status");
    const orderNumber = searchParams.get("razorpay_payment_link_reference_id");

    if (status === "paid") {
      // Pass all razorpay params to HueHoppers backend callback
      const params = new URLSearchParams({
        razorpay_payment_link_id:
          searchParams.get("razorpay_payment_link_id") || "",
        razorpay_payment_id: searchParams.get("razorpay_payment_id") || "",
        razorpay_payment_link_reference_id:
          searchParams.get("razorpay_payment_link_reference_id") || "",
        razorpay_payment_link_status: status,
        razorpay_signature: searchParams.get("razorpay_signature") || "",
      });
      window.location.href = `${HUEHOPPERS_BACKEND_URL}/api/payments/payment_link_callback?${params.toString()}`;
      return;
    }

    // ── Case 3: Payment failed/cancelled ──
    window.location.href = `${HUEHOPPERS_FRONTEND_URL}/cart`;
  }, []);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        backgroundColor: "#fff",
        gap: 20,
      }}
    >
      {/* Spinner */}
      <div
        style={{
          width: 48,
          height: 48,
          border: "4px solid #e0e0e0",
          borderTop: "4px solid #2c3a34",
          borderRadius: "50%",
          animation: "spin 0.8s linear infinite",
        }}
      />

      <p
        style={{
          fontSize: 18,
          fontWeight: 600,
          color: "#2c3a34",
          letterSpacing: 0.5,
        }}
      >
        Redirecting...
      </p>

      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
